__turbopack_context__.v({
  "wrapper": "MoneyPostLayout-module__xNqiEG__wrapper",
});
